var map = {
	"./de/detail-btn.png": "n4Vs",
	"./en/detail-btn.png": "tlTx",
	"./es/detail-btn.png": "LRoT",
	"./fr/detail-btn.png": "bgH+",
	"./ja/detail-btn.png": "cA5c",
	"./ko/detail-btn.png": "elqU",
	"./pt/detail-btn.png": "Vuhp",
	"./ru/detail-btn.png": "uFzy",
	"./th/detail-btn.png": "LM9X",
	"./zh-Hant/detail-btn.png": "G64H"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "RR92";